export enum TransactionType {
  message = 'plmessage',
  localFilteringMessage = 'message',
  command = 'command',
  dataFile = 'dataFile',
}

export enum SortByType {
  gatewayReceiptTime = 'gatewayReceiptTime',
  fileTypeName = 'fileTypeName',
  messageCreationTime = 'messageCreationTime',
  lastUpdateTime = 'lastUpdateTime',
  status = 'status',
}

export enum OrderByType {
  ASC = 'ASC',
  DESC = 'DESC',
}
